"use client";

export { useTranslation } from "react-i18next";
